import funerals from "@/constants/funeral_detail.json";

import { GetStaticPaths, GetStaticPathsResult, GetStaticProps } from "next";

import { skipDevBuildInGetStaticPaths } from "@/utils/skipDevBuildInGetStaticPaths";

export const getStaticPaths: GetStaticPaths = async () => {
  const skipBuildResult = skipDevBuildInGetStaticPaths() as GetStaticPathsResult;
  if (skipBuildResult) {
    return skipBuildResult;
  }

  const paths = funerals.map((funeral) => ({
    params: {
      id: funeral.name,
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.id as string;
  const name = slug;
  let id;
  let sangjoInfoData;
  let packagesData;
  let sangjoIntroData;
  let sangjoFAQData;

  if (name) {
    const funeral = funerals.find((res: { name: string }) => res.name === name);

    if (funeral) {
      id = funeral.id;
      sangjoInfoData = funeral.sangjoInfoData;
      packagesData = funeral.packagesData;
      sangjoIntroData = funeral.sangjoIntroData;
      sangjoFAQData = funeral.sangjoFAQData;
    }
  }

  return {
    props: {
      id,
      name,
      sangjoInfoData,
      packagesData,
      sangjoIntroData,
      sangjoFAQData,
      automatedVariables: [name, sangjoInfoData?.short_introduction, id],
    },
  };
};

export { FuneralContainer as default } from "containers/FuneralContainer";
